import React from "react";
import login from "../../assets/login/login.svg";
import logo from "../../assets/login/okaygoLogo.svg";
export default function Banner({ heading }) {
  return (
    <section className="w-full flex flex-col gap-7 pb-5 items-center">
      <div className="w-full">
        <img src={login} alt="Login-Background" className="w-full h-auto" />
      </div>
      <div className="w-full flex flex-col items-center gap-[10px]">
        <div className="">
            <img src={logo} alt="" />
        </div>
        <div className="font-bold leading-6 text-[16px] text-[#1C75BC]">{heading}</div>
      </div>
    </section>
  );
}
